export default __webpack_public_path__ + "static/studio-slider-30-c03b809068da50103f7840178a99f1ae.png";